const niceURL = require('./nice-url')
const conf = require('./conf')

module.exports = niceURL(conf.backendURL, conf.backendOutsidePort)
